import type { PublicMessageThread } from '@adieuu/shared';

/**
 * Replaces a root's thread summary with the server's stored copy (null means
 * no replies remain). A summary older than the one shown came from an
 * out-of-order event and is ignored; redelivery of the same event is a no-op.
 */
export function applyThreadSummary<M extends { thread?: PublicMessageThread }>(
  root: M,
  summary: PublicMessageThread | null,
): M {
  if (!summary) {
    if (!root.thread) return root;
    const { thread: _drop, ...rest } = root;
    return rest as M;
  }
  if (root.thread && summary.lastReplyAt < root.thread.lastReplyAt) return root;
  return { ...root, thread: summary };
}
